var styles = {
  "Toolbar": "_Toolbar_emc0z_34",
  "Layout": "_Layout_emc0z_42",
  "ControlsContainer": "_ControlsContainer_emc0z_47",
  "AdditionalActionsContainer": "_AdditionalActionsContainer_emc0z_55",
  "Controls": "_Controls_emc0z_47",
  "Section": "_Section_emc0z_71",
  "disabled": "_disabled_emc0z_85",
  "ButtonContainer": "_ButtonContainer_emc0z_89",
  "OverflowContainer": "_OverflowContainer_emc0z_98",
  "SectionBreak": "_SectionBreak_emc0z_111",
  "Overflow": "_Overflow_emc0z_98",
  "Measurer": "_Measurer_emc0z_150"
};

export { styles as default };
